var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.linkClass,attrs:{"data-testid":"toggle-favorite-off","href":"#"},on:{"click":_vm.favoriteItem}},[_c('i',{class:_vm.starClass})])}
var staticRenderFns = []

export { render, staticRenderFns }